import React, { useState } from 'react';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import {
    AccountPaginationContainer,
    Footer,
    MobileView,
    PaginationContainerMobile,
} from './InventoryFooter.styled';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { TextBold } from 'src/common/components/filter/Filters.styled.jsx';
import { storeItemTableData } from 'src/pages/consignmentBilling/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { setProgressBarStatus } from 'src/pages/consignmentBilling/redux/actions';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getRoutePathWithParams, isIpad } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const InventoryFooter = ({
    inventoryDetails,
    itemsVal,
    page,
    first,
    onPageChange,
    totalResults,
    customStyle = {
        position: 'fixed',
        width: { standard: 'calc(100% - 5rem)', smallDevice: '100%' },
        padding: '10px',
        inPaddingVertical: '5px',
    },
    searchItem,
    checked,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const history = useHistory();
    const [footerBottomOffset, setFooterBottomOffset] = useState(0);

    useEffectWithErrorLogging(() => { }, [page]);

    // useEffectWithErrorLogging(() => {
    //     const viewport = window.visualViewport;

    //     if (!isIpad() || !viewport) {
    //         setFooterBottomOffset(0);
    //         return;
    //     }

    //     const updateFooterOffset = () => {
    //         const gap = Math.max(
    //             0,
    //             window.innerHeight - (viewport.height + viewport.offsetTop)
    //         );
    //         const maxFooterOffset = 320;
    //         setFooterBottomOffset(Math.min(gap, maxFooterOffset));
    //     };

    //     updateFooterOffset();
    //     viewport.addEventListener('resize', updateFooterOffset);
    //     viewport.addEventListener('scroll', updateFooterOffset);
    //     window.addEventListener('orientationchange', updateFooterOffset);

    //     return () => {
    //         viewport.removeEventListener('resize', updateFooterOffset);
    //         viewport.removeEventListener('scroll', updateFooterOffset);
    //         window.removeEventListener('orientationchange', updateFooterOffset);
    //         setFooterBottomOffset(0);
    //     };
    // }, []);

    const itemTableData = useSelector(
        (state) => state.consignmentBilling.itemTableData
    );
    const checkedItems = useSelector(
        (state) => state.inventoryReducer.checkedItems
    );
    let errorMsg = checked?.some(
        (item) => item && (item.flag === true || item.used === '')
    );
    const count = checkedItems.reduce((counter, obj) => {
        if (obj && obj.isChecked === true) counter += 1;
        return counter;
    }, 0);
    // const saveSelectedItems = (e) => {
    const saveSelectedItems = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        if (checkedItems && checkedItems?.length > 0) {
            // const itemArr = itemsVal.length > 0 ? itemsVal :filterCheckedItems;
            const items = checkedItems
                .filter((item) => item != undefined)
                .map((itemData) =>
                    !itemData?.lotSerial?.[0]?.Serial || !itemData.lotSerialUnknown
                        ? {
                            ...itemData,
                            lotSerial: [
                                {
                                    Serial:
                                        itemData.lotSerial ||
                                        itemData?.lotSerial?.[0]?.Serial,
                                    Used: itemData.used,
                                    isInvalidQtyMsg: null,
                                },
                            ],
                            uom: itemData?.uom ? itemData.uom : 'EA',
                        }
                        : { ...itemData }
                );
            let key = new Set(items.map((d) => d.uniqueKey));
            let newData = [
                ...items,
                ...itemTableData.filter((d) => !key.has(d.uniqueKey)),
            ];
            // console.log('beforeselecteditems', items, itemTableData);
            // Array.prototype.push.apply(items, itemTableData);
            // let newData = items.filter(
            //     (v, i, a) =>
            //         a.findIndex((t) => t.uniqueKey === v.uniqueKey) === i
            // );
            // console.log('addselecteditems', items, itemTableData, newData);
            dispatch(storeItemTableData(newData));
            history.replace(getRoutePathWithParams('/consignmentBilling'));
            dispatch(setProgressBarStatus('Account'));
        }
    };

    return (
        <>  
            <AccountPaginationContainer>
              {inventoryDetails && inventoryDetails.length > 0 && (
                    <BasicPagination
                        totalRecords={
                            searchItem && searchItem.length > 0
                                ? inventoryDetails.length
                                : totalResults
                        }
                        recordsFetched={
                            inventoryDetails && inventoryDetails.length
                        }
                        pageNumber={page}
                        handleChange={(e) => onPageChange(e)}
                        first={first}
                        mobilePadding={'2% 2% 5% 2%'}
                        content={t('pagination.showingProductText')}
                        style={{
                            width: 'calc(100% - 5rem)',
                        }}
                        width={'58%'}
                        marginLeft={'12px'}
                        noMarginRight={true}
                    />
                )}
            </AccountPaginationContainer> 
            {/* <AccountPaginationContainer
                width={'calc(100vw - 5rem)'}
                 position={'sticky'}
                 justifySelf={'anchor-center'}
                > 
                <Footer> */} 
                        <BottomNavigation
                            isInventoryFooter={true}
                            justifyContent="space-around"
                            moblieJustifyContent="space-evenly"
                            padding={customStyle.padding}
                            // bottom={`${footerBottomOffset}px`}
                            bottom={'0'}
                            right={'0'}
                            position={customStyle.position}
                            zIndex={'3001'}
                            width={customStyle.width}
                            inventoryWidth={true}
                            justifyContentCenter={true}
                            paddingBottom={true}
                            isConsignmentBilling={true}
                        >
                            <BottomNavigationButtonContainer>
                                <Button
                                    id={'consignmentBilling-inventoryFooter-saveSelectedItems'}
                                    show={true}
                                    variant={
                                         checkedItems &&
                                            checkedItems.length > 0 &&
                                            !errorMsg
                                            ? ButtonStyles?.primary
                                            : ButtonStyles.disabled
                                    }
                                    width={'220px'}
                                    height={'38px'}
                                    clicked={saveSelectedItems}
                                    disabled={
                                        checkedItems &&
                                            checkedItems.length > 0 &&
                                            !errorMsg
                                            ? false
                                            : true
                                    }
                                >    
                                    <TextBold color={'#FFFFFF'} style={{ fontSize: '16px' }}>
                                        {t('consignmentBilling.inventory.addSelectedItems')} (
                                        {count != undefined ? count : '0'})
                                    </TextBold>
                                </Button>
                            </BottomNavigationButtonContainer>
                        </BottomNavigation> 
                {/* </Footer>
            </AccountPaginationContainer> */}

        
            <MobileView>
                    <PaginationContainerMobile padding={'15px'}>
                        {inventoryDetails && inventoryDetails.length > 0 && (
                            <BasicPagination
                                totalRecords={
                                    searchItem && searchItem.length > 0
                                        ? inventoryDetails.length
                                        : totalResults
                                }
                                recordsFetched={
                                    inventoryDetails && inventoryDetails.length
                                }
                                pageNumber={page}
                                handleChange={(e) => onPageChange(e)}
                                first={first}
                                mobilePadding={'2% 2% 2% 2%'}
                                content={t('consignmentBilling.inventory.showingProducts')}
                            />
                        )}
                    </PaginationContainerMobile>
                    <Footer>
                        <BottomNavigation
                            justifyContentCenter={true}
                            paddingBottom={true}
                            opacity={'1'}
                            border={'1px solid #1010EB'}
                            justifyContent={'right'}
                            moblieJustifyContent={'center'}
                            bottom={'0'}
                            left={'0'}
                            right={'0'}
                            position={'inherit !important'}
                        >
                            <Button
                                id={'consignmentBilling-inventoryFooter-saveSelectedItems-mobile'}
                                show={true}
                                variant={
                                    checkedItems &&
                                        checkedItems.length > 0 &&
                                        !errorMsg
                                        ? ButtonStyles?.primary
                                        : ButtonStyles?.disabled
                                }
                                top={'659px'}
                                left={'670px'}
                                width={'332px'}
                                height={'38px'}
                                clicked={saveSelectedItems}
                                disabled={
                                    checkedItems &&
                                    checkedItems.length > 0 &&
                                    !errorMsg
                                        ? false
                                        : true
                                }
                            >
                                <TextBold color={'#FFFFFF'} style={{ fontSize: '16px' }}>
                                    {t('consignmentBilling.inventory.addSelectedItems')} (
                                    {count != undefined ? count : '0'})
                                </TextBold>
                            </Button>
                        </BottomNavigation>
                    </Footer>
                </MobileView>

        </>
    );
};
export default InventoryFooter;

const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    touch-action: manipulation;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    @media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
        /* For ipad landscape layouts only */
        margin-right: 35px;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
        smallJustifyContent ? smallJustifyContent : 'center'};
        margin: ${(props) =>
        props.tabletPortraitMargin ? props.tabletPortraitMargin : ''};
    }

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        margin-right: 35px;
    }
    
    @media only screen and (min-device-width: 1080px) and (max-device-width: 1090px) and (orientation: landscape) {
        margin-right: 3rem;
    }

    ${media.mobileDevice`
        justify-content: space-evenly;
    `}
`;
